import { ApiRoomContainer, ApiSeason } from '@ibe/api';
import React, { ReactNode, Ref, RefObject } from 'react';
import { DatePickerRef } from '../DatePicker/DatePicker';
import { DateRangeDurationPropsType } from '../../../SubModules/PackageSearch/PackageSearch';
import { HighlightDatesInformation } from './DateRangeInput';
import ServiceSearchDetailParams from '../../../SubModules/ServiceSearch/ServiceSearchDetailParams';
import { DatePickerProps } from '../DatePicker/DatePickerInModal';

export const PACKAGE_CODE = 'code';
export const SALES_CHANNEL_CODE = 'salesChannelCode';
export const ITEM = 'item';
export const OCCUPANCY = 'occupancy';
export const INVALID_DATE_STRING = 'Invalid Date';

export type WeekDayConstraints = {
  fromDate?: string;
  toDate?: string;
  weekDays?: number[];
};

export interface DateRangeInputProps {
  customDateFormat?: boolean;
  startDate?: string;
  endDate?: string;
  occupancy?: ApiRoomContainer[];
  onChange?: (startDate: string | undefined, endDate: string | undefined) => void;
  onSubmit?: (startDate: string | undefined, endDate: string | undefined) => void;
  minDate?: Date;
  maxDate?: Date;
  minDateRangeSpan?: number; // number of days needs at least to be selected between start date and the end of this range
  maxDateRangeSpan?: number; // number of days allowed to be selected between start date and the end of this range
  id?: string;
  seasons?: ApiSeason[];
  noDatePickerOverflow?: boolean;
  updateStateFromProps?: boolean;
  datePickerRef?: Ref<DatePickerRef>;
  disabled?: boolean;
  weekDayConstraints?: WeekDayConstraints[];
  duration?: DateRangeDurationPropsType;
  ignoreStartDateForFilter?: boolean;
  selectsDisabledDaysInRange?: boolean;
  useAdvancedFeatures?: boolean;
  focusSelectedMonth?: boolean;
  monthsShown?: number;
  customDivider?: React.ReactNode;
  CustomInput?: ReactNode;
  CustomHeader?: ReactNode;
  onCalendarClose?: () => void;
  onCalendarCloseDated?: (startDate: string | undefined, endDate: string | undefined) => void;
  popoverRef?: RefObject<HTMLDivElement | null>;
  popoverTargetRef?: RefObject<HTMLElement>;
  dateRangeInputRef?: Ref<{
    togglePopover: () => void;
    openPopover: () => void;
    closePopover: () => [startDate?: string, endDate?: string];
    getCurrentDateRange: () => [startDate?: string, endDate?: string];
  }>;
  stateFromPropsOnPopoverOpen?: boolean;
  useLocalSelectedDatesForInRangeCheck?: boolean;
  onMonthChange?: () => void;
  onYearChange?: () => void;
  onCalendarOpen?: () => void;
  onPopoverToggle?: () => void;
  fillWithLastDateRangeWhenNoSelection?: boolean;
  clearSelectionsOnOpen?: boolean;
  withColorCodedAvailability?: boolean;
  selectedRoomServiceUnitTypeCode?: string;
  showDateSelectionInModal?: boolean;
  modalLabel?: string;
  highlightDatesInformation?: HighlightDatesInformation;
  searchParams?: Partial<ServiceSearchDetailParams>;
  validationErrorComponent?: (errorKeys?: string[]) => ReactNode;
  selectsRange?: boolean;
  showPopperArrow?: boolean;
  withHeader?: boolean;
  renderInline?: boolean;
  minMonthShown?: number; // override default mobile
  popperPlacement?: DatePickerProps['popperPlacement'];
}
